import React, { Component, createRef } from 'react'
import './FolderMenu.scss'
import { ModuleContext } from '../contexts/ModuleContext'
import { ResourceImage } from '../Types'
import Img from 'react-image'
import './learninglab/LearningPanel.scss'
import Draggable from 'react-draggable'
import { ReactComponent as ExitImage } from '../assets/icons/exit-media-button.svg'


interface Props {
    folderDiagrams: ResourceImage[]
    folderMenuIsVisible: boolean
    hideFolderMenu: Function
}

interface State {
    modalShow: boolean
    selectedDiagrams: ResourceImage[]
    diagramSel: ResourceImage | null
}

export default class FolderMenu extends Component<Props, State> {
    static contextType = ModuleContext
    context!: React.ContextType<typeof ModuleContext>
    folderMenu = createRef<HTMLDivElement>()

    state: State = {
        modalShow: false,
        selectedDiagrams: [],
        diagramSel: null,
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClick)
    }

    handleClick = (event: any) => {
        const wasOutside = !(event.target.contains === this.folderMenu)

        if (wasOutside && this.props.folderDiagrams) {
            this.props.hideFolderMenu()
            document.removeEventListener('click', this.handleClick)
        }
    }

    setModalShow = (value: boolean) => {
        this.setState({ modalShow: value })
    }

    setFolderInfo = (e: React.MouseEvent, diagram: ResourceImage) => {
        e && e.preventDefault()
        if (this.state.selectedDiagrams.indexOf(diagram) > -1) return

        const diagramArr = this.state.selectedDiagrams
        diagramArr.push(diagram)

        this.setState({ selectedDiagrams: diagramArr })
    }

    cleanUp = (diagram: ResourceImage) => {
        let diagramArr = this.state.selectedDiagrams
        delete diagramArr[this.state.selectedDiagrams.indexOf(diagram)]

        if (Object.keys(diagramArr).length === 0) {
            diagramArr = []
        }
        this.setState({ selectedDiagrams: diagramArr })
    }

    showMenu() {
        document.addEventListener('click', this.handleClick)
    }

    updateSelected = (diagram: ResourceImage) => this.setState({ diagramSel: diagram })


    renderSelectedDiagrams = (diagram: ResourceImage, idx: number, selectedDiagram: ResourceImage | null) => {
        const assetsPath = process.env.PUBLIC_URL + '/assets/images/' + this.context.user.electricalCode + '/'
        const width = window.outerWidth
        const height = window.outerHeight

        const zIndexClass = diagram === selectedDiagram ? 'diagram-top-z-index' : ''

        return (
            <Draggable
                key={'ri' + idx}
                bounds={{ top: -height, left: -width, right: width, bottom: height }}
                positionOffset={{ x: '-10vw', y: '-80vh' }}
                onDrag={() => this.updateSelected(diagram)}
            >
                <div
                    onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
                        e.preventDefault()
                        this.updateSelected(diagram)
                    }}
                    className={zIndexClass}
                >
                    <div className='diagram img-fluid'>
                        <div className="exitButton" onClick={() => this.cleanUp(diagram)}>
                            <ExitImage />
                        </div>
                        <Img alt='' src={assetsPath + diagram.filename} />
                    </div>
                </div>
            </Draggable>
        )

    }

    render() {
        const { folderDiagrams, folderMenuIsVisible } = this.props
        const { selectedDiagrams, diagramSel } = this.state

        folderMenuIsVisible && this.showMenu()

        const diagramItems = folderDiagrams && folderDiagrams.length > 0
            ? folderDiagrams.map((diagram: ResourceImage, idx: number) => {
                return (
                    <div key={'d' + idx} className="menu--option" onClick={(e: React.MouseEvent) => this.setFolderInfo(e, diagram)}>
                        {diagram.name}
                    </div>
                )
            })
            : []

        const visibleDiagrams = selectedDiagrams.map((diagram: ResourceImage, idx: number) => this.renderSelectedDiagrams(diagram, idx, diagramSel))

        return (
            <>
                <div ref={this.folderMenu}>
                    {(folderMenuIsVisible) && (
                        <div className="folder-menu offset">
                            <div className="folder-menu--option disabled">References</div>
                            <div className="folder-menu--separator" />
                            {diagramItems}
                        </div>
                    )}
                </div>

                <div className={'interactive'}>
                    {visibleDiagrams}
                </div>
            </>
        )
    }

}
